export class Translations {
    entries: ITranslation[];

    constructor(
        Label: ITranslation[],
    ) {
        this.entries = Label;
    }

    static empty(): Translations {
        return { entries: []};
    }
}

interface ITranslation {
    [key: string]: string;
};
